import React from "react";

interface ServiceCellProps {
  serviceName: string;
}

export const ServiceCell: React.FC<ServiceCellProps> = ({ serviceName }) => {
  return <span>{serviceName}</span>;
};
